module.exports = __webpack_public_path__ + "static/img/teacher4.d9c951a4.png";